import styled, { keyframes } from "../styled";
import { Skeleton } from "./skeleton";
export const skeletonLoadingAnimation = keyframes `
  0% {
    opacity: 100%;
  }
  50% {
    opacity: 40%;
  }
  100% {
    opacity: 100%;
  }
`;
const FORWARDED_PROP_EXCLUDES = [
    "borderRadius",
    "width",
    "height",
    "lines",
    "size",
];
const FORWARDED_PROP_INCLUDES = ["animate"];
export const SkeletonStyled = styled(Skeleton).withConfig({
    shouldForwardProp: (prop, defaultValidator) => {
        if (FORWARDED_PROP_EXCLUDES.includes(prop)) {
            return false;
        }
        if (FORWARDED_PROP_INCLUDES.includes(prop)) {
            return true;
        }
        return defaultValidator(prop);
    },
}) `
  background-color: ${(p) => p.theme._ui.colors.surface.border.disabled};
  height: ${(p) => p.height || "100%"};
  width: ${(p) => p.width || "100%"};
  border-radius: ${(p) => p.borderRadius || p.theme._ui.radii.xSmall};
  flex-grow: ${(p) => (!p.height || p.height === "100%" ? "1" : "unset")};
  display: inline-flex;
  line-height: 1;
  opacity: 1;
  user-select: none;
  overflow: hidden;
  z-index: 1; /* Necessary for overflow: hidden to work correctly in Safari */
  animation: 1.5s infinite linear ${skeletonLoadingAnimation};

  ${(p) => p.animate === false && "animation: unset;"}

  @media (prefers-reduced-motion) {
    animation: unset;
  }
`;
SkeletonStyled.displayName = "Skeleton";
